import styled, { css } from 'styled-components';
import { always } from 'ramda';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { renderWhenTrue } from '@utils/rendering';
import { FONT_STYLE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

const getBackgroundStyles = renderWhenTrue(
  always(css`
    background-color: ${COLORS.WHITE40};
    backdrop-filter: saturate(180%) blur(10px);
  `)
);

export const Container = styled.div<{ showBackground: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
  transition: backdrop-filter 0.5s ease-in-out, background-color 0.5s ease-in-out;
  ${({ showBackground }) => getBackgroundStyles(showBackground)}

  ${media.tablet} {
    padding: 0;
    background-color: transparent;
    width: auto;
  }
`;

export const TopRow = styled.div<{ showBackground: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 12px;
  ${({ showBackground }) =>
    showBackground &&
    css`
      box-shadow: 0 0 15px 0 ${COLORS.BLACK10};
    `}
`;

export const BottomRow = styled.div`
  width: 100%;
`;

const textStyles = css`
  ${typography({})};
`;

export const Artist = styled.a`
  display: block;
  text-transform: uppercase;
  margin-right: 30px;
  ${textStyles};
`;

export const Title = styled.span<{ italic?: boolean }>`
  font-style: ${({ italic }) => (italic ? FONT_STYLE.ITALIC : FONT_STYLE.NORMAL)};

  * {
    display: inline-block;
    padding: 0;
    margin: 0;
    hyphens: auto;
  }

  .no-italic {
    font-style: ${FONT_STYLE.NORMAL};
  }
`;

export const Details = styled.div`
  max-width: calc(100% - 150px);

  ${media.mobile} {
    max-width: unset;
  }
`;

export const DetailsRow = styled.div<{ isSecondary?: boolean }>`
  word-break: break-word;
  ${textStyles};
  ${({ isSecondary }) =>
    isSecondary &&
    css`
      color: ${COLORS.SILVER_CHALICE};
    `}
`;

export const FavoriteButtonContainer = styled.div`
  margin-right: -10px;
  margin-top: -6px;

  svg {
    width: 12px;
  }

  button {
    padding: 0;
  }

  ${media.tablet} {
    margin-right: unset;
    margin-top: unset;
    position: absolute;
    top: -11px;
    right: -12px;
  }
`;

export const DimensionButton = styled.button`
  padding: 0;
  border-bottom: 1px solid ${COLORS.BLACK15};

  &:hover {
    border-bottom: 1px solid ${COLORS.BLACK};
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${media.tablet} {
    margin: ${OFFSET.M} 0 ${OFFSET.S};
    width: 100%;
  }
`;

export const ActionsContainer = styled.div`
  ${media.tablet} {
    width: 100%;
  }
`;

export const KlarnaContainer = styled.div`
  margin-bottom: ${OFFSET.M};
  margin-top: ${OFFSET.M};
  display: none;

  ${media.tablet} {
    display: block;
  }
`;
